import { render } from "./OverviewHeaderOpportunity.vue?vue&type=template&id=b84e0552&scoped=true"
import script from "./OverviewHeaderOpportunity.vue?vue&type=script&lang=js"
export * from "./OverviewHeaderOpportunity.vue?vue&type=script&lang=js"

import "./OverviewHeaderOpportunity.vue?vue&type=style&index=0&id=b84e0552&lang=scss&scoped=true"
import "./OverviewHeaderOpportunity.vue?vue&type=style&index=1&id=b84e0552&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b84e0552"]])

export default __exports__